import { Component, Prop, Watch } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';

@Component
export class ApartmentPriceViewSwitch extends BaseComponent {
	isTableViewValue: boolean = true

	viewChange(i:boolean) {
		this.isTableViewValue = i;
		this.$emit('updateIsTableView', i);
    }

	mounted() {
  console.log("Child mounted");
}
}

export default ApartmentPriceViewSwitch;
